import { useEffect, useState, useRef } from "react";
import Material_Inspector from "./components/Material_Inspector";
import Model_Inspector from "./components/Model_Inspector";
import ProductARViewer from "./components/ProductARViewer";
import ProductPublicViewer from "./components/ProductPublicViewer";
  import "./styles.css";
  import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';


export default function App() {

  const MODEL_VIEWER_KEY = 'JKQ76HB9AB4HLNH8FK4';

  const id = window.location.search.split("?id=")[1];
  const PRODUCTURL = 'https://d48f7equ64qjl.cloudfront.net/product_assets/glb/';
  // const PRODUCTURL = 'https://storage.googleapis.com/all3d/product_assets/glb/';
  // const PRODUCTURL = 'https://d48f7equ64qjl.cloudfront.net/test_files/0008303c-a376-40d2-82eb-10a5c7dd1b3a/doll.zip';
 
 
  const [origin, setOrigin] = useState(null);
  const [key, setkey] = useState(null);
  const [modelUrl, setModelUrl] = useState(null);
  const [modelType, setModelType] = useState('glb');
  const [metadata, setMetadata] = useState(null);
  const [groupProducts, setGroupProducts] = useState(null);
  const [configuratorMode, setConfiguratorMode] = useState(false);
  const [debugMode, setDebugMode] = useState(false);
  const [materialDebugMode, setMaterialDebugMode] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [paddings, setPaddings] = useState([]);
  const [iframeId, setIframeId] = useState(null);
  const [eventSource, setEventSource] = useState(null);
  const [modelLoadingStatus, setModelLoadingStatus] = useState('loading');
  const [patternOptions, setPatternOptions] = useState(null);
  const [hdri, setHdri] = useState(null);
  
  const eventSourceRef = useRef(null);
  const originRef = useRef(null);
  const iframeIdRef = useRef(null);

  const handleModelLoadingStatus = (status, errorMessage = null) => {
    setModelLoadingStatus(status);
    sendModelLoadingStatus(status, errorMessage);
  };

  const sendModelLoadingStatus = (status, errorMessage = null) => {
    
    const currentEventSource = eventSource || eventSourceRef.current;
    const currentOrigin = origin || originRef.current;
    const currentIframeId = iframeId || iframeIdRef.current;
    
    if (currentEventSource !== null && currentOrigin !== null) {
      const message = {
        type: 'model-viewer-status',
        iframeId: currentIframeId,
        status: status,
        timestamp: Date.now()
      };
      
      if (errorMessage) {
        message.errorMessage = errorMessage;
      }
      
      try {      
        setTimeout(() => {
          if (window.parent && window.parent !== window) {
            window.parent.postMessage(message, '*');
          }
        }, 200);
      } catch (error) {
        console.error('Error sending message:', error);
      }
    }
  };

  
  useEffect(()=> {
    window.addEventListener(
      "message",
      (event) => {
        setEventSource(event.source);
        if (event.data.glbURL) {
          setkey(event.data.key);
          setOrigin(event.origin);
          setModelUrl(event.data.glbURL);
          setModelType(event.data.modelType || 'glb');
          setMetadata(event.data.metadata);
          setGroupProducts(event.data.groupProducts);
          setDebugMode(event.data.debugMode);
          setConfiguratorMode(event.data.configuratorMode);
          setPaddings(event.data.paddings || []);
          setIframeId(event.data.iframeId);
          setPatternOptions(event.data.patternOptions);
          setHdri(event.data.hdri);
        }
        else if (event.data.modelURL) {
          setkey(event.data.key);
          setOrigin(event.origin);
          setModelUrl(event.data.modelURL);
          setModelType(event.data.modelType || 'unified');
          setMetadata(event.data.metadata);
          setGroupProducts(event.data.groupProducts);
          setDebugMode(event.data.debugMode);
          setConfiguratorMode(event.data.configuratorMode);
          setPaddings(event.data.paddings || []);
          setIframeId(event.data.iframeId);
          setPatternOptions(event.data.patternOptions);
          setHdri(event.data.hdri);
        } else if (event.data.materialDebugMode) {
          setMaterialDebugMode(event.data.materialDebugMode);
        }
        else if (event.data.selected_products) {
          setSelectedProducts(event.data.selected_products);
        }
      },
      false,
    );
  },[])

  useEffect(() => {
    eventSourceRef.current = eventSource;
  }, [eventSource]);
  
  useEffect(() => {
    originRef.current = origin;
  }, [origin]);
  
  useEffect(() => {
    iframeIdRef.current = iframeId;
  }, [iframeId]);

  useEffect(() => {
    if (eventSource && origin && iframeId) {
      eventSource.postMessage({
        type: 'model-viewer-status',
        iframeId: iframeId,
        status: modelLoadingStatus,
      }, origin);
    }
  }, [eventSource, origin, iframeId, modelLoadingStatus]);

  
  
  return (
      <Router>
        <Routes>
          <Route exact path="/ar-viewer/:id" element={<ProductARViewer />}  />
          <Route exact path="/" element={<Material_Inspector materialDebugMode={materialDebugMode} />} />
          <Route exact path="/public-viewer" element={<ProductPublicViewer />} />
          <Route exact path="/material_inspector" element={<Material_Inspector materialDebugMode={materialDebugMode} />} />          
          {( modelUrl != null && modelUrl != undefined) ?
            <Route exact path="/model_inspector"
              element={<Model_Inspector
                modelUrl={modelUrl}
                modelType={modelType}
                metadata={metadata}
                groupProducts={groupProducts}
                configuratorMode={configuratorMode}
                selectedProducts={selectedProducts}
                debugMode={debugMode}
                paddings={paddings}
                onLoadingStatus={handleModelLoadingStatus}
                hdri = {hdri}
                patternOptions = {patternOptions}
              />} />
            : ''}
        </Routes>
      </Router>     
  );
}